// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 4681) return "static/chunks/4681-29c1ff2fe3876945.js";
	if (chunkId === 7620) return "static/chunks/7620-f4d76d5bc8b82173.js";
	if (chunkId === 2082) return "static/chunks/2082-0a0b52b977011527.js";
	if (chunkId === 6342) return "static/chunks/6342-9d41aea786330e3c.js";
	if (chunkId === 2683) return "static/chunks/2683-9508574bdf6e09bc.js";
	if (chunkId === 240) return "static/chunks/c36f3faa-5b0c31b2e0a4ea4a.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"244":"825bbe59eb8a397e","1191":"14d1d6136de866dc","1695":"9df52ac13581d93e","5319":"e36c49771b25ef5e","6573":"73036d6adab963d1","7630":"c72a4555bdd94c8d","8380":"78bea0f3056f72e8"}[chunkId] + ".js";
};